import React from 'react';
import { PropsWithChildren } from 'react';
import cls from 'classnames';
import styles from './Dropdown.module.scss';
import { AnchorVerification } from './DropdownAnchor';

export * from './DropdownAnchor';
export * from '../Sharing/ShareDropdown';
export * from '../Sharing/ShareTargets/Generic';

export function Dropdown({
  children,
  maxWidth,
  spacing = '10px',
  className,
  align = 'left',
  invert = false,
  ...rest
}: PropsWithChildren<DropdownProps>) {
  const style: React.CSSProperties = maxWidth !== undefined ? { maxWidth } : {};
  const verifyParent = React.useContext(AnchorVerification);

  // It doesn't make sense to use a Dropdown element without a parent anchor that determines
  // where the dropdown is going to be rendered. In these cases we want to throw an error so
  // it's easier to debug the issue
  verifyParent();

  if (align === 'left') {
    style.left = '0';
  }

  return (
    // Using `margin` on the dropdown element for spacing by itself breaks the continuity of the hover
    // So this is needed to create some spacing above the dropdown.
    <div
      className={cls(styles.dropdownWrapper, className, { [styles.invert]: invert })}
      style={invert ? { marginBottom: spacing } : { paddingTop: spacing }}
      {...rest}
    >
      <aside className={cls(styles.dropdown, { [styles.invert]: invert })} style={style}>
        {children}
      </aside>
    </div>
  );
}

export type DropdownProps = React.HTMLAttributes<HTMLDivElement> & {
  align?: 'left' | 'right';
  spacing?: string | number;
  maxWidth?: string | number;
  invert?: boolean;
};
